(() => {
  const countdowns = document.querySelectorAll('[data-drop-countdown]');
  if (!countdowns.length) return;

  const pad = (value) => String(value).padStart(2, '0');

  countdowns.forEach((countdown) => {
    const context = countdown.closest('[data-drop-release-at]');
    const releaseAt = context?.dataset.dropReleaseAt;
    const status = context?.dataset.dropStatus;
    const target = Date.parse(releaseAt || '');

    if (status !== 'prelaunch' || !Number.isFinite(target)) {
      countdown.hidden = true;
      return;
    }

    let interval;
    const update = () => {
      const remaining = Math.max(0, target - Date.now());
      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      countdown.textContent = `${pad(days)}D ${pad(hours)}H ${pad(minutes)}M ${pad(seconds)}S`;

      if (remaining === 0) {
        if (interval) window.clearInterval(interval);
        window.dispatchEvent(new CustomEvent('perfection:drop-reached'));
      }
    };

    update();
    if (target > Date.now()) interval = window.setInterval(update, 1000);
  });
})();
